import React from 'react';
import ServiceDetailPage from './ServiceDetailPage';
export default function BathroomRemodelingMiami() {
  return <ServiceDetailPage slug="bathroom-remodeling-miami" />;
}
